<template>
  <van-list
    ref="vanList"
    v-model="loading"
    :finished="finished"
    :finished-text="finishedText"
    :immediate-check='false'
    @load="onLoad"
    >
    <div class="box">
      <!-- <div class="title">
        <div
          class="allCompany"
          v-for="(item, index) in tabTitleList"
          :key="index"
          :class="{ select: isShowIndex === index }"
          @click="getAllCompany(index)"
        >{{item.name}}</div>
      </div> -->
      <tab :tabList="tabTitleList" ref="tab" :name="'dataTab'" @onSwitch="myPending" class="tabList"></tab>
      <div class="searchBox">
        <img src="../../../../assets/image/sousuo_ic_daoyou @2x (1).png"/>
        <input type="text" placeholder="请输入企业名称或者门店名称" v-model="enterpriseListValue" />
      </div>
      <div class="count" v-show="isShowIndex === 0">
        <div class="countingCategory" @click="rateCategory">
          <span class="countingCategory_title">{{ title }}</span>
          <img src="../../../../assets/image/xiala.png" alt />
        </div>
        <div class="quantity">{{total}}家</div>
      </div>
      <div class="countNum" v-show="isShowIndex === 1 || isShowIndex === 2 || isShowIndex === 3 || isShowIndex === 4 || isShowIndex === 5 || isShowIndex ===6">共{{total}}家</div>
      <div class="list">
        <div class="filterBy">
          <div class="condition">
            <!-- 区域下拉 -->

            <div class="adress" @click="selectCity" v-show='cityListFlag'>
              <span class="city">{{cityChange}}</span>
              <img src="../../../../assets/image/ic_jiantou_down@2x.png" alt />
            </div>

            <div class="adress"  v-show='!cityListFlag'>
              <span class="city">{{cityChange}}</span>
              <img src="../../../../assets/image/ic_jiantou_down@2x.png" v-show='cityListFlag' alt />
            </div>

            <div class="format" @click="formatSelection">
              <span class="city">{{activities}}</span>
              <img src="../../../../assets/image/ic_jiantou_down@2x.png" alt />
            </div>
          </div>
          <div class="period" @click="handleUpOrDown">
            <span>{{typeDataTitle}}</span>
            <div class="periodImg">
              <img src="../../../../assets/image/ic_px@2x.png" v-show="!isUpSort" />
              <img src="../../../../assets/image/ic_d_px@2x.png" v-show="isUpSort" />
            </div>
          </div>
        </div>
        <!-- 全部业态，评分标准，重点关注，黑名单 -->
        <ul v-if="true">
          <li class="line_bottom" :class="{line_bottom_none: (index+ 1) === enterpriseList.length}" v-for="(item, index) in enterpriseList" :key="index" @click="goScoreDetails(index)">
            <div class="photo">
              <img src="../../../../assets/image/ic_qytx@3x.png" alt />
            </div>
            <div class="situation">
              <div class="companyName">
                <!-- <span>{{item.name.slice(0, item.name.indexOf(enterpriseListValue))}}</span>
                <span class="highlight">{{item.name.slice(item.name.indexOf(enterpriseListValue),item.name.indexOf(enterpriseListValue)+enterpriseListValue.length)}}</span>
                <span>{{item.name.substr(item.name.indexOf(enterpriseListValue)+enterpriseListValue.length)}}</span> -->
                <p class="name" :style="{'width':change?'74%':'66%'}">{{item.name}}</p>
                <div :class="{colorType: item.score>6?false:true}" class="stateType" v-if="true">
                  <span class="num" v-if='item.score && item.businessStatus !== 11 && item.businessStatus !== 12'>{{item.score.toFixed(2)}}</span><span v-if='item.score && item.businessStatus !== 11 && item.businessStatus !== 12' class="numSize">分</span>
                  <span v-if='!item.score && item.businessStatus !== 11 && item.businessStatus !== 12' class="numColor">待评分</span>
                  <span v-if='item.businessStatus === 11' class="numColor">已停业</span>
                  <span v-if='item.businessStatus === 12' class="numColor">已变更</span>
                  <!-- <span  v-if='!item.score' class="numColor">已停业</span> -->
                </div>
                <!-- <div class="stateType">
                     <span class="stateChange" v-if="true">经营范围变更</span>
                     <span class="stateChange" v-if="false">停业</span>
                </div> -->
              </div>
              <div class="information">
                <div class="left">
                  <div class="companyAdress line_border_blue" v-if="item.regionCode"><div class="companyAdressItem">{{item.regionCode}}</div></div>
                  <div class="companyCategory line_border_green" v-if="item.industryCategory"><div class="companyCategoryItem">{{item.industryCategory}}</div></div>
                </div>
                <!-- <div class="right">
                  <div :class="{colorType: item.score>6?false:true}">
                    <span class="num" v-if='item.score'>{{item.score.toFixed(2)}}</span><span v-if='item.score' class="numSize">分</span>
                    <span  v-if='!item.score' class="numColor">待评分</span>
                  </div>
                </div> -->
              </div>
              <div
                class="updateTime1"
                v-if='item.lastUpdateTime'
                v-show="isShowIndex === 0 || isShowIndex === 1 || isShowIndex === 4 || isShowIndex === 5"
              >更新时间：{{item.lastUpdateTime |filtTime}}</div>
              <div v-show="isShowIndex === 2">
                <div class="updateTime" v-show='item.enteredTime'>进入重点关注时间：{{item.enteredTime | filtTime}}</div>
                <div class="rectificationTimeRemain">
                  <div v-if="item.changeTimeDay" class="exceedTime">{{item.changeTime}}</div>
                  <div v-else>{{item.changeTime}}</div>
                </div>
              </div>
              <div
                class="updateTime"
                v-if='item.enteredTime'
                v-show="isShowIndex === 3"
              >进入黑名单时间：{{item.enteredTime | filtTime}}</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 总数 -->
      <common-picker :cols="colsCount" ref="commonpickerCount" :typeList="typeListCount" @getTypeValue="getCountValue"></common-picker>
      <!-- 全部业态 -->
      <common-picker :cols="colsCount" ref="commonpickerAll" :typeList="typeListAll" @getTypeValue="getAllValue"></common-picker>
      <!-- 区域 -->
      <common-picker :cols="cols" v-if="cityListFlag" ref="commonpicker" :typeList="typeList"  @getTypeValue="getCityValue"></common-picker>
      </div>
    </div>
  </van-list>
</template>
<script>
    import commonPicker from '../../../../components/base/commonPicker';
    import api from '../../../../service/modules/integrity';
    import { channer } from '../../../../utils/configJson.js';
    import tab from './tab'
    import { storageGetByName } from '../../../../utils/helper'
    export default {
        components: {
            'common-picker': commonPicker,
            tab
        },
        data () {
            return {
                pageIndex: 1, // 当前页码
                pageSize: 20,
                finishedText: '',
                loading: false,
                finished: false,
                enterpriseListValue: '', // 搜索
                typeDataTitle: '更新时间', // 头部Tab更新时间切换
                tabTitleList: [
                    {
                        name: '全部已评',
                        code: 'all'
                    },
                    {
                        name: '评分达标',
                        code: 'online' // 需修改
                    },
                    {
                        name: '重点关注',
                        code: 'supervision'
                    },
                    // {
                    //     name: '黑名单',
                    //     code: 'blacklist'
                    // },
                    // {
                    //     name: '正常经营',
                    //     code: 'normal'
                    // },
                    // {
                    //     name: '停业',
                    //     code: 'stop'
                    // },
                    // {
                    //     name: '经营范围变更',
                    //     code: 'change'
                    // },
                    // {
                    //     name: '无法评分',
                    //     code: 'noline'
                    // }
                ],
                enterpriseList: [], // 涉旅企业列表
                total: 0, // 查询总条数
                isUpSort: false, // 正序or倒序
                isShowIndex: 0,
                typeListAll: [], // 全部业态
                activities: '全部行业',
                typeListCount: [], // 总数 待评数
                typeTabList: [], // 总数 待评数
                title: '', // 头部总数
                type: '', // 头部总数列表 参数
                cityChange: '', // 区域改变
                cityCode: '', // 区域code
                typeList: [], // 区域
                cols: 2,
                colsCount: 1,
                cityListFlag: true,
                regionCode: '', // 地区code
                industryCategory: '', // 行业类别
                asc: false, // 正序 (默认)
                noList: false,
                change: false,
                isShowList: false
            };
        },
        watch: {
            'enterpriseListValue' (val) {
                this.isShowList = true;
                this.enterpriseList = []
                this.pageIndex = 1
                this.enterpriseListValue = val;
                this.getEnterpriseList(); // 涉旅企业列表  dictType
            }
        },
        mounted () {
            if (this.$route.query.code == 'online') {
                this.typeDataTitle = '诚信指数'
                this.$broadcast('getIndex', 1);
            } else if (this.$route.query.code == 'supervision') {
                this.typeDataTitle = '进入重点关注时间'
                this.$broadcast('getIndex', 2);
            } else if (this.$route.query.code == 'blacklist') {
                this.typeDataTitle = '进入黑名单时间'
                this.$broadcast('getIndex', 3);
            } else if (this.$route.query.code == 'normal') {
                this.typeDataTitle = '更新时间'
                this.$broadcast('getIndex', 0);
            } else if (this.$route.query.code == 'stop') {
                this.typeDataTitle = '更新时间'
                this.$broadcast('getIndex', 0);
            } else if (this.$route.query.code == 'change') {
                this.typeDataTitle = '更新时间'
                this.$broadcast('getIndex', 0);
            // } else if (this.$route.query.code == 'normal') {
            //     this.typeDataTitle = '更新时间'
            //     this.$broadcast('getIndex', 3);
            } else {
                this.$broadcast('getIndex', 0);
            }
        },
        async created () {
            this.isShowIndex = Number(this.$route.query.ind)
            this.title = this.$route.query.name ? decodeURIComponent(this.$route.query.name) : '总数'
            this.cityChange = this.$route.query.cityName ? decodeURIComponent(this.$route.query.cityName) : '全省';
            console.log(this.$route);
            this.cityCode = this.$route.query.cityCode;
            this.type = this.$route.query.code || 'all'
            console.log(1111000000, this.isShowIndex, this.title, this.cityChange, this.cityCode, this.type)
            if (localStorage.getItem('title')) {
                this.industryCategory = JSON.parse(localStorage.title).code
                this.activities = JSON.parse(localStorage.title).name
            } else {
                this.industryCategory = ''
                this.activities = '全部行业'
            }
            if (localStorage.areaFlag == 1) {
                this.cityCode = JSON.parse(localStorage.getItem('integrityInfo')).regionCode
            } else if (this.$store.state.integrity.userInfo.cityCode) {
                this.cityCode = this.$store.state.integrity.userInfo.cityCode
            }
            console.log('localStorage.citylList', localStorage.citylList)
            if (localStorage.citylList) { 
              this.typeList = JSON.parse(localStorage.citylList); 
            } else {
              let res = await storageGetByName('cityList', {
                regionCode: this.cityCode
              })
              this.typeList = res
            }
            if (this.$store.state.integrity.userInfo.cityName) {
                this.cityChange = this.$store.state.integrity.userInfo.cityName
            }
            if (localStorage.cityFlag == 1) {
                this.cols = 2;
                this.cityListFlag = true;
            } else if (localStorage.proFlag == 1) {
                this.cols = 2;
                this.cityListFlag = true;
            } else if (localStorage.areaFlag == 1) {
                this.cols = 1;
                this.cityListFlag = false;
            }
            this.getEnterpriseList() // 涉旅企业列表  dictType
            this.getindustryCategory(); // 业态列表
            this.getTab(); // 头部总数列表
        },
        methods: {
            myPending (item) {
                if (item === 'all') {
                    console.log(this.$refs.tab);
                    this.typeDataTitle = '更新时间';
                    this.title = this.typeTabList[0].text
                    this.isShowIndex = 0;
                } else if (item === 'online') {
                    this.typeDataTitle = '诚信指数';
                    this.isShowIndex = 1;
                } else if (item === 'supervision') {
                    this.typeDataTitle = '进入重点关注时间';
                    this.isShowIndex = 2;
                } else if (item === 'blacklist') {
                    this.typeDataTitle = '进入黑名单时间';
                    this.isShowIndex = 3;
                 } else if (item === 'normal') {
                    this.typeDataTitle = '更新时间';
                    this.isShowIndex = 4;
                } else if (item === 'stop') {
                    this.typeDataTitle = '更新时间';
                    this.isShowIndex = 5;
                // } else if (item === 'noline') {
                //     this.typeDataTitle = '更新时间';
                //     this.isShowIndex = 6;
                } else if (item === 'change') {
                    this.typeDataTitle = '更新时间';
                    this.isShowIndex = 6;
                }
                this.type = item;
                this.pageIndex = 1
                this.enterpriseList = []
                this.getEnterpriseList();
            },
            onLoad () {
                ++this.pageIndex;
                this.isShowList = false;
                this.getEnterpriseList();
            },
            // 详情
            goScoreDetails (e) {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.enterpriseList[e].id
                    }
                });
            },
            // 业态列表
            getindustryCategory () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        res.data.unshift({ code: '', name: '全部行业' })
                        let arr = res.data;
                        arr = JSON.parse(
                            JSON.stringify(arr)
                                .replace(/name/g, 'text')
                                .replace(/code/g, 'value')
                        );
                        this.typeListAll.push(arr);
                    }
                });
            },
            // 头部左边总数列表
            getTab () {
                this.typeTabList = [
                    {
                        text: '总数',
                        value: 'all'
                    },
                    {
                        text: '正常经营',
                        value: 'normal'
                    },
                    {
                        text: '停业',
                        value: 'stop'
                    },
                    {
                        text: '经营范围变更',
                        value: 'change'
                    }
                    // {
                    //     text: '未评数',
                    //     value: 'UnGraded'
                    // },
                    // {
                    //     text: '已评数',
                    //     value: 'Graded'
                    // },
                    // {
                    //     text: '无法评分数',
                    //     value: 'cannot'
                    // }

                ];
                this.typeListCount.push(this.typeTabList);
            },
            // 正序or倒序
            handleUpOrDown () {
                this.asc = !this.asc;
                this.isUpSort = !this.isUpSort;
                this.pageIndex = 1
                this.enterpriseList = []
                this.getEnterpriseList();
            },
            // 获取城市
            selectCity () {
                this.$refs.commonpicker.showPicker();
            },
            // 切换城市
            getCityValue (value) {
                if (value && value.length > 1) {
                    if (value[1].text === '--') {
                        this.cityChange = value[0].text;
                        this.cityCode = value[0].value;
                    } else {
                        this.cityChange = value[1].text;
                        this.cityCode = value[1].value1;
                    }
                } else if (value && value.length == 1) {
                    this.cityChange = value[0].text;
                    this.cityCode = value[0].value;
                }
                this.pageIndex = 1
                this.enterpriseList = []
                this.getEnterpriseList();
            },
            // 涉旅企业列表
            getEnterpriseList () {
                let data = {
                    pageIndex: this.pageIndex, // 当前页码
                    pageSize: this.pageSize, // 分页条数
                    industryCategory: this.industryCategory, // 行业类别
                    enterpriseName: this.enterpriseListValue, // 企业名称
                    regionCode: this.cityCode, // 区划编码
                    type: this.type, // 业态 blacklist:黑名单 supervision:重点关注 online
                    asc: this.asc // 排序码，false: 正序(默认)， true: 倒序
                };
                api.getEnterpriseList(data).then(res => {
                    if (res.ret === 0) {
                        let data = res.data
                        if (res.data.list.length == 0) {
                            this.noList = true
                        } else {
                            this.noList = false
                        }
                        for (var i = 0; i < data.list.length; i++) {
                            let time = Math.floor(
                                (new Date().valueOf() - data.list[i].enteredTime) / (1000 * 60 * 60 * 24)
                            );
                            let time1 = data.list[i].periodDay
                            let time2 = data.list[i].rePeriodDay + data.list[i].periodDay

                            if (time <= time1) {
                                data.list[i].changeTime = ` 剩余监管期: ${time1 - time}天`;
                            }
                            if (time > time1 && time <= time2) {
                                data.list[i].changeTime = `剩余评分时间: ${time2 - time}天`;
                            }
                            if (time > time2) {
                                data.list[i].changeTime = `评分已超期: ${time - time2}天`;
                                data.list[i].changeTimeDay = time;
                            }
                        }
                        this.total = data.pageination.total;
                        let arr = data.list
                        if (arr.length > 0) {
                          if (this.isShowList) {
                            this.enterpriseList = arr;
                            
                          } else {
                            
                            this.enterpriseList = this.enterpriseList.concat(arr)
                            this.finished = false
                          }
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                    }
                });
            },
            // tab切换
            getAllCompany (index) {
                if (index === 0) {
                    this.typeDataTitle = '更新时间';
                    this.title = this.typeTabList[0].text
                } else if (index === 1) {
                    this.typeDataTitle = '诚信指数';
                } else if (index === 2) {
                    this.typeDataTitle = '进入重点关注时间';
                } else if (index === 3) {
                    this.typeDataTitle = '进入黑名单时间';
                }
                this.isShowIndex = index;
                this.type = this.tabTitleList[index].value;
                this.pageIndex = 1
                this.enterpriseList = []
                this.getEnterpriseList();
            },
            // 全部业态
            formatSelection () {
                this.$refs.commonpickerAll.showPicker();
            },
            // 总数
            rateCategory () {
                this.$refs.commonpickerCount.showPicker();
            },
            // 总数
            getCountValue (val) {
                // if (val[0].text !== '总数') {
                //     this.typeDataTitle = '诚信指数';
                // }
                this.title = val[0].text;
                this.type = val[0].value;
                this.enterpriseList = []
                this.pageIndex = 1
                this.getEnterpriseList();
            },
            // 业态
            getAllValue (val) {
                this.activities = val[0].text;
                this.industryCategory = val[0].value;
                this.pageIndex = 1
                this.enterpriseList = []
                this.getEnterpriseList();
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            getDuration (mtime) {
                var days = mtime / 1000 / 60 / 60 / 24;
                var daysRound = Math.floor(days);
                var time = daysRound;
                return time;
            }
        }
    };
</script>
<style lang="less" scoped>

.box {
  width: 100%;
  min-height: 100%;
  // padding: 12px;
  box-sizing: border-box;
  background-color: #fbfbfb;
  .tabList{
    margin-left:10px;
  }
  .noListBox{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    >img{
      width: 74px;
      height: 62px;
      margin: 0 auto 24px;
      display: block;
    }
    >h4{
      font-size: 14px;
      text-align: center;
      color: #999;
    }
  }
  .title {
    width: 100%;
    height: 58px;
    display: flex;
    line-height: 58px;
    box-sizing: border-box;
    padding: 24px 12px 12px 12px;
    .allCompany{
      height: 26px;
      line-height: 26px;
      margin-right: 24px;
      // color: #333;
      font-size: 14px;
    }

    .select {
      color: #36b374;
      border-bottom: 2px solid #36b374;
    }
  }
  .searchBox {
    margin: 8px 12px;
    background-color: #f5f5f5;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;

    > img {
      display: inline-block;
      width: 15px;
      height: 15px;
      position: absolute;
      top: 6px;
      left: 16px;
    }

    > input {
      width: 100%;
      height: 28px;
      line-height: 28px;
      padding: 0 16px 0 40px;
      box-sizing: border-box;
      border-radius: 2px;
      background-color: #f5f5f5;
    }
    input::-webkit-input-placeholder {
      color: #999999;
    }
    input::-moz-input-placeholder {
      color: #999999;
    }
    input::-ms-input-placeholder {
      color: #999999;
    }
  }
  .select {
    color: #36b374;
    border-bottom: 2px solid #36b374;
    font-weight: bold;
  }
  .count {
    width: 100%;
    // height: 44px;
    display: flex;
    padding: 0 12px;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 12px;
    .countingCategory {
      margin-top: 12px;
      height: 20px;
      line-height: 20px;
      font-size: 20px;
      font-weight: bold;
      font-weight: 700;
      color: #333;
      .countingCategory_title {
        float: left;
      }
      img {
        display: inline-block;
        width: 7px;
        height: 5px;
        margin-top: 7.5px;
        margin-left: 3px;
        float: right;
      }
    }
    .quantity {
      margin-top: 15px;
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #666;
    }
  }
  .countNum {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    margin-top: 6px;
    height: 38px;
    line-height: 38px;
    margin-left: 12px;
  }
  .list {
    // width: 100%;
    margin: 0 12px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 16px 0 0 0;
    overflow: hidden;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    .filterBy {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      line-height: 16px;
      color: #666;
      padding: 0 16px;
      .condition {
        .adress,
        .format {
          display: inline-block;
          span {
            float: left;
          }
          .city {
            float: left;
            max-width: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 6px;
          }
          img {
            float: right;
            display: inline-block;
            width: 6px;
            height: 4px;
            margin-top: 4px;
          }
        }
        .format {
          margin-left: 16px;
        }
      }
      .period {
        display: flex;
        justify-content: center;
        align-items: center;
        .periodImg {
          margin-left: 6px;
          img {
            display: inline-block;
            width: 13px;
            height: 11px;
            color: #eeeeee;
          }
        }
      }
    }
    ul {
      // padding: 0 16px;
      li {
        list-style: none;
        display: flex;
        padding: 16px;
        .photo {
          width: 84px;
          height: 84px;
          img {
            display: inline-block;
            width: 84px;
            height: 84px;
          }
        }
        .situation {
          width: 100%;
          padding-left: 12px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .companyName {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            .name{
              font-size:14px;
              font-weight: 700;
              color: #333;
              width:66%;
              line-height: 1.3em;
            }
            .stateType{
              color:@base-color;
              margin-top:2px;
              .num {
                font-size: 16px;
                font-weight: bold;
                .numSize{
                  font-size: 10px;
                }
              }
              .numColor{
                color: #999;
                font-size: 12px;
                display: inline-block;
                margin-top:1px;
              }
              .stateChange{
                font-size:12px;
                color:#999999;
                display: inline-block;
                margin-top:1px;
              }

            }
            .colorType {
              color: #ff4d4d!important;
            }

            // font-size: 14px;
            // font-weight: bold;
            // color: #333;
            // line-height: 20px;
            // display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 2;
            // overflow: hidden;
            // .highlight{
            //   color: @base-color;
            //   font-weight: bold;
            // }

          }
          .information {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            .left {
              display: flex;
              align-items: left;
              font-size: 12px;
              .companyAdress {
                color:#2283e6;
                margin-right: 8px;
                  .companyAdressItem{
                    max-width: 108px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 14px;
                    font-size: 10px;
                    line-height: 14px;
                    text-align: center;
                    -webkit-transform: scale(0.84);
                    padding: 0 4px 0 4px;
                  }
              }
              .companyCategory {
                color: @base-color;
                .companyCategoryItem{
                    height: 14px;
                    font-size: 10px;
                    line-height: 14px;
                     text-align: center;
                       padding: 0 4px 0 4px;
                  -webkit-transform: scale(0.84);
                }
              }
            }
            // .right {
            //   color: @base-color;
            //   .num {
            //     font-size: 16px;
            //     font-weight: bold;
            //     .numSize{
            //       font-size: 10px;
            //     }
            //   }
            //   .numColor{
            //     color: #999;
            //     font-size: 12px;
            //   }
            // }
          }
          // ul {
          //   width: 100%;
          //   li {
          //     list-style: none;
          //     display: flex;
          //     padding: 16px 0;
          //     border-bottom: 1px solid #eeeeee;
          //     .photo {
          //       width: 84px;
          //       height: 84px;
          //       img {
          //         display: inline-block;
          //         width: 84px;
          //         height: 84px;
          //       }
          //     }
          //     // .situation {
          //     //   width: 100%;
          //     //   // padding-left: 12px;
          //     //   .companyName {
          //     //     font-size: 14px;
          //     //     font-weight: bold;
          //     //     color: #333;
          //     //     line-height: 20px;
          //     //   }
          //     //   .information {
          //     //     display: flex;
          //     //     justify-content: space-between;
          //     //     margin-top: 5px;
          //     //     .left {
          //     //       display: flex;
          //     //       .companyAdress {
          //     //         float: left;
          //     //         // background: @base-color;
          //     //         color: #2283e6;
          //     //         font-size: 12px;
          //     //         border: 1px solid #2283e6;
          //     //         -webkit-transform: scale(0.84);
          //     //         padding: 2px 4px;
          //     //         // margin-left: -6px;
          //     //       }
          //     //       .companyCategory {
          //     //         border: 1px solid @base-color;
          //     //         -webkit-transform: scale(0.84);
          //     //         color: @base-color;
          //     //         padding: 2px 4px;
          //     //       }
          //     //     }
          //     //     .right {
          //     //       color: @base-color;
          //     //       .num {
          //     //         font-size: 16px;
          //     //         font-weight: bold;
          //     //       }
          //     //     }
          //     //   }
          //     //   .updateTime {
          //     //     font-size: 12px;
          //     //     color: #666;
          //     //     margin-top: 12px;
          //     //   }
          //     //   .rectificationTimeRemain {
          //     //     font-size: 12px;
          //     //     color: #666;
          //     //     margin-top: 10px;
          //     //     .exceedTime {
          //     //       color: #ff4d4d;
          //     //     }
          //     //   }
          //     // }
          //   }
          // }
          .updateTime1 {
            font-size: 12px;
            color: #666;
            // margin-top: 32px;
          }
          .updateTime {
            font-size: 12px;
            color: #666;
            margin-top: 9px;
          }
          .rectificationTimeRemain {
            font-size: 12px;
            color: #666;
            margin-top: 9px;
            .exceedTime {
              color: #ff4d4d;
            }
          }
        }
      }
      .line_bottom_last{
        border-bottom-color: #fff;
        border-bottom: 0px
      }
    }
    .nolisted {
      position: relative;
      width: 100%;
      height: 500px;
      background-color: #fbfbfb;
      img {
        position: absolute;
        left: 50%;
        top: 30%;
        margin-left: -25px;
        display: block;
        width: 50px;
      }
      div {
        font-size: 14px;
        color: #adaeae;
        position: absolute;
        top: 30%;
        margin-top: 50px;
        left: 50%;
        margin-left: -30px;
      }
    }
  }
}
</style>
<style>
.van-search {
  background: #fbfbfb !important;
}
.van-search__content {
  background: #fff;
}
</style>
